import { render, staticRenderFns } from "./MainSliders.vue?vue&type=template&id=73e5de64&"
import script from "./MainSliders.vue?vue&type=script&lang=js&"
export * from "./MainSliders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports